import type { PlainEnvironment } from "@/queries/environment-queries";
import { getBranchFromInitializer } from "@/utils/environment";
import { useMemo } from "react";

export function getBranch(environment?: PlainEnvironment) {
    // Use the branch if available
    if (environment?.status?.content?.git?.branch) {
        return environment.status.content.git.branch;
    }

    // If the branch is not available and there are failure messages, then default to
    // "no branch"
    if ((environment?.status?.failureMessage?.length ?? 0) > 0) {
        return "no branch";
    }

    // Fall back to get the branch from the initializer
    return getBranchFromInitializer(environment?.spec?.content?.initializer);
}

export function useBranch(environment?: PlainEnvironment) {
    const branch = useMemo(() => getBranch(environment), [environment]);
    return branch;
}
